<script setup>
import { computed } from "vue";
import SVGIcon from "@/components/SVGIcon.vue";
import Block from "@/components/redesign/Block/Block.vue";
import Spot from "@components/Spot/Spot.vue";
import { useScreenSize } from "../../../../mixins/useScreenSize";

const size = useScreenSize();
const isDesktop = computed(() => size.value === "desktop");
const iconColor = computed(() => (isDesktop.value ? "#f7f3eb" : "#26355e"));
</script>

<template>
  <div class="partners-wrapper">
    <div class="partners-background">
      <Spot
        width="163"
        height="153"
        top="42"
        right="115"
        color="gold"
        blur="75"
        opacity="1"
        rotate="90"
        z="0"
        mobile
      />
      <Spot
        width="222"
        height="208"
        top="0"
        right="-16"
        z="1"
        blur="93"
        opacity="1"
        mobile
      />

      <Spot
        width="391"
        height="367"
        top="0"
        left="345"
        rotate="180"
        color="gold"
        blur="135"
        desktop
      />
      <Spot class="untouchable" top="0" left="0" rotate="180" z="-2" desktop />
    </div>
    <Block>
      <div class="partners-container">
        <h2 class="r-h4-to-h2 italic" :class="{ 'text-dark': !isDesktop }">
          Trusted by
          <br />
          these leagues’ athletes
        </h2>
        <div class="partners-list-container">
          <div class="partners-list">
            <SVGIcon
              name="partners-ufc"
              :width="!isDesktop ? 141 : 188"
              :color="iconColor"
            />
            <SVGIcon name="partners-nfl" width="48" :color="iconColor" />
            <SVGIcon
              name="partners-w"
              :width="!isDesktop ? 52 : 69"
              :color="iconColor"
            />
            <SVGIcon
              name="partners-major-league"
              :width="!isDesktop ? 93 : 125"
              :color="iconColor"
            />
            <SVGIcon
              name="partners-olympic"
              :width="!isDesktop ? 105 : 141"
              :color="iconColor"
            />
            <SVGIcon
              name="partners-wsl"
              :width="!isDesktop ? 140 : 210"
              :color="iconColor"
            />
          </div>
        </div>
      </div>
    </Block>
  </div>
</template>
<style scoped src="./style.scss" lang="scss" />
